export default "__VITE_ASSET__C7sn2YWb__"